import {api as axios} from '../../shared/axios';
import { API_URL } from "../../shared/config";


export const createNewDevice = async (data) => {
    try {
        const request = await axios.post(`${API_URL}/device/?easy_setup=true&huawei_device=true`, data);
        return { data: request.data, error: undefined };
    } catch (error) {
        return { data: undefined, error: error };
    }
}

export const updateAddress = async (id,data) => {
    try {
        const request = await axios.patch(`${API_URL}/geography/${id}/`, data);
        console.log(request);
        return { data: request.data, error: undefined };
    } catch (error) {
        return { data: undefined, error: error };
    }
}

export const createCompany = async (data) => {
    try {
        const request = await axios.post(`${API_URL}/company/`, data,{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data',
            }
        });
        console.log(request);
        return { data: request.data, error: undefined };
    } catch (error) {
        return { data: undefined, error: error };
    }
}
